import dayjs from 'dayjs';

/**
 * TCR-2523 — chú thích "Tồn AMIS cập nhật lúc ..." dưới thanh lọc của popup Tra cứu
 * tồn kho.
 *
 * Tồn AMIS do một tiến trình nền kéo về mỗi 15 phút, nên nó LUÔN có độ trễ so với
 * tồn ERP. Người dùng cần biết số liệu mình đang đọc là mới hay cũ — thiếu mốc thời
 * gian thì hai cột tồn cạnh nhau trông như đã khớp trong khi thực ra lệch nhau vì
 * lệch thời điểm.
 */

/** Sau 60 phút không kéo được AMIS thì coi là số liệu có thể cũ. */
export const AMIS_STALE_AFTER_MINUTES = 60;

export interface AmisAsOfNote {
  /** Câu chú thích đầy đủ để hiện ra UI. */
  text: string;
  /** Số liệu đã quá 60 phút so với hiện tại → cảnh báo "số liệu có thể cũ". */
  stale: boolean;
  /** Thời điểm đã định dạng `dd/mm HH:mm`. */
  formattedAsOf: string;
}

/**
 * Dựng chú thích từ `amis_as_of` của response.
 *
 * Trả `null` khi BE không trả (`undefined`/`null`) hoặc trả chuỗi không parse được —
 * lúc đó không hiện gì cả, đừng hiện mốc thời gian sai cho người dùng.
 */
export function buildAmisAsOfNote(
  amisAsOf: string | null | undefined,
  now: Date = new Date(),
): AmisAsOfNote | null {
  if (!amisAsOf) return null;
  const asOf = dayjs(amisAsOf);
  if (!asOf.isValid()) return null;

  const formattedAsOf = asOf.format('DD/MM HH:mm');
  const stale = now.getTime() - asOf.valueOf() > AMIS_STALE_AFTER_MINUTES * 60_000;

  return {
    formattedAsOf,
    stale,
    text:
      `Tồn AMIS cập nhật lúc ${formattedAsOf} (tự kéo từ AMIS mỗi 15 phút)` +
      (stale ? ' — số liệu có thể cũ' : ''),
  };
}
